import { Grid, Typography } from "@mui/material";

import CoinSelectItem from "pages/Wallet/Component/FilterMarginHistory/Component/CoinSelectItem";
import DatePicker from "components/DatePicker";
import React from "react";
import Select from "components/Select";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

function InvestmentRequestFilters() {
  const [searchParams, setSearchParams] = useSearchParams();

  const investmentForm = useSelector(
    (state) => state.investment.investmentHistoryForm?.data
  );

  const defaultValues = {
    coinId: +searchParams.get("coinId") || -1,
    portfolioId: +searchParams.get("portfolioId") || -1,
    startDate: searchParams.get("startDate") || "",
    endDate: searchParams.get("endDate") || "",
    sideId: +searchParams.get("sideId") || 0,
  };

  const { watch, setValue } = useForm({ defaultValues });

  const handleChange = (value, fieldName) => {
    setValue(fieldName, value);
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      page: 1,
      [fieldName]: value,
    });
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={4}>
        <Typography variant="label" color="text.secondary">
          Coin
        </Typography>

        <Select
          items={investmentForm?.lisCoin}
          itemText="name"
          itemValue="id"
          value={watch("coinId")}
          dir="ltr"
          onChange={(e) => handleChange(e.target.value, "coinId")}
          customValue={(data) => <CoinSelectItem data={data} />}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="label" color="text.secondary">
          Portfolio
        </Typography>

        <Select
          items={investmentForm?.lisPortfolio}
          itemText="name"
          itemValue="id"
          value={watch("portfolioId")}
          onChange={(e) => handleChange(e.target.value, "portfolioId")}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="label" color="text.secondary">
          Side
        </Typography>

        <Select
          items={investmentForm?.lisSide}
          itemText="name"
          dir="ltr"
          itemValue="id"
          value={watch("sideId")}
          onChange={(e) => handleChange(e.target.value, "sideId")}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="label" color="text.secondary">
          Start Date
        </Typography>

        <DatePicker
          value={watch("startDate")}
          onChange={(e) => handleChange(e, "startDate")}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="label" color="text.secondary">
          End Date
        </Typography>

        <DatePicker
          value={watch("endDate")}
          onChange={(e) => handleChange(e, "endDate")}
        />
      </Grid>
    </Grid>
  );
}

export default InvestmentRequestFilters;
